export const SETREPORTSLIST = "SETREPORTSLIST";
export const SETMODULELIST = "SETMODULELIST";
export const SETPARAMLIST = "SETPARAMLIST";
export const SETREPORTOUTPUT = "SETREPORTOUTPUT";
export const SETACCESSLIST = "SETACCESSLIST";
export const SETSUPERUSER = "SETSUPERUSER";
export const SETCONTENT = "SETCONTENT";